import {ItemWithCustomComponent} from './types';

export function hasCustomComponent<T>(item: T): item is T & ItemWithCustomComponent {
    return typeof item === 'object' && item !== null && 'useCustomComponent' in item;
}

export function hasSubLabel<T>(item: T): item is T & {subLabel: string} {
    return typeof item === 'object' && item !== null && 'subLabel' in item;
}
